import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import "./Translation.css";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";

function EditTranslationLanguage(props) {
  const { id } = useParams();
  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  const [editLanguage, setEditLanguage] = useState({
    name: "",
    code: "",
    slug: "",
    active: "",
    site_default_language: "",
  });
  const [defaultLanguage, setDefaultLanguage] = useState("");
  const [editsiteLanguage, setEditSiteLanguage] = useState("");
  const [loading, setLoading] = useState(true);
  const [validationMessagename, setValidationMessagename] = useState("");
  const [validationMessagecode, setValidationMessagecode] = useState("");
  const [validationMessageslug, setValidationMessageslug] = useState("");
  const [isValidationHiddenname, setIsValidationHiddenname] = useState(true);
  const [isValidationHiddencode, setIsValidationHiddencode] = useState(true);
  const [isValidationHiddenslug, setIsValidationHiddenslug] = useState(true);
  const [isDefaultChecked, setIsDefaultChecked] = useState(editLanguage.code === defaultLanguage);
  useEffect(() => {
    setIsDefaultChecked(editLanguage.code === defaultLanguage);
  }, [editLanguage, defaultLanguage]);

  const nameInputRef = useRef(null);
  const getLanguageData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/translate-language/edit/${id}`,
        { headers: headers }
      );
      setEditLanguage(response?.data?.Languages);
      setActive(response?.data?.Languages.active);
      setDefaultLanguage(response?.data?.site_default_language);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  useEffect(async () => {
    getLanguageData();
  }, []);
  //console.log(editLanguage);
  const [active, setActive] = useState("");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditLanguage((prevEditLanguage) => ({
      ...prevEditLanguage,
      [name]: value,
    }));
    setValidationMessagename("");
    setIsValidationHiddenname(true);
    setValidationMessagecode("");
    setIsValidationHiddencode(true);
    setValidationMessageslug("");
    setIsValidationHiddenslug(true);
    setEditLanguage({ ...editLanguage, title: e.target.value });
    setEditLanguage({ ...editLanguage, [e.target.name]: e.target.value });
  };
  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const handleUpdate = async (e) => {
    let focusInputRef = null;

    if (editLanguage?.name === "") {
      setValidationMessagename("Name cannot be empty.");
      setIsValidationHiddenname(false);
      focusInputRef = nameInputRef;
    }
    if (editLanguage?.code === "") {
      setValidationMessagecode("Code cannot be empty.");
      setIsValidationHiddencode(false);
      focusInputRef = nameInputRef;
    }
    if (editLanguage?.slug === "") {
      setValidationMessageslug("Slug cannot be empty.");
      setIsValidationHiddenslug(false);
      focusInputRef = nameInputRef;
    }

    if (focusInputRef) {
      focusInputRef.current.focus();
      return;
    }

    e.preventDefault();

    const editInputvalue = {
      name: editLanguage?.name,
      code: editLanguage?.code,
      slug: editLanguage?.slug,
      active: editLanguage?.active,
      site_default_language: isDefaultChecked ? editLanguage.code : null,
    };
    let firstApiStatus = false;
    let resultapi = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/translate-language/update/${id}`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res.json();

      if (resjson.status === true) {
        resultapi = resjson;
        toast.success(resultapi?.message);
      }
      else if (resjson.status === false) {
        resultapi = resjson;
        toast.error(resultapi?.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleCheckbox = (e) => {
    if (e.target.checked === true) {
      setEditLanguage({ ...editLanguage, [e.target.name]: 1 });
    } else {
      setEditLanguage({ ...editLanguage, [e.target.name]: 0 });
    }
  };
  useEffect(() => {
    if (editLanguage.code === defaultLanguage) {
      setDefaultLanguage(editLanguage.code);
    }
  }, [editLanguage]);
  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setIsDefaultChecked(checked);
  };


  // const handleCheckboxChange = (e) => {
  //   if (e.target.checked === true) {
  //     setEditLanguage({  ...editLanguage, [e.target.name]: editLanguage?.code });
  //   } else {
  //     setEditLanguage({  ...editLanguage, [e.target.name]: '' });
  //   }
  // };
  // const handleCheckboxChange1 = (e) => {
  //   const { name, checked } = e.target;

  //   setDefaultLanguage((prevState) => {
  //     if (checked) {
  //       return { ...prevState, [name]: editLanguage?.code }  ;

  //     } else {
  //       const { [name]: removed, ...rest } = prevState;
  //       return rest;
  //     }
  //   });
  // };

  //console.log(editLanguage?.code == defaultLanguage)
  return (
    <>
      {<AdminBackNavigation path={`${'/translate-languages'}`} text="Back" />}
      <AdminSaveHeader heading={"Edit Translation Languages"} saveText={"Update"} saveMethod={handleUpdate} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageLabel text={"Name"} className="mandatorySimple" />
            <AdminCustomInput type="text" name="name" placeHolder={"Enter name"} value={editLanguage?.name} onChange={handleChange} ref={nameInputRef} error={validationMessagename} />
            <MessageLabel text={"Slug"} className="mandatorySimple" />
            <AdminCustomInput type="text" name="slug" placeHolder={"Enter slug"} value={editLanguage?.slug} onChange={handleChange} ref={nameInputRef} error={validationMessageslug} />
            <MessageLabel text={"Short Code"} className="mandatorySimple" />
            <AdminCustomInput type="text" name="code" placeHolder={"Enter code"} value={editLanguage?.code} onChange={handleChange} ref={nameInputRef} error={validationMessagecode} />
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={"Status Setting"} />
            <div className="d-flex justify-content-between ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Status"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'active'} checked={editLanguage?.active === 1} onChange={handleCheckbox} />
              </div>
            </div>
            <div className="d-flex justify-content-between ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Set Default Language"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'site_default_language'} checked={isDefaultChecked} onChange={handleCheckboxChange} />
              </div>
            </div>
          </Wrapper>
        </RightWrapper>
      </FormContainer >

    </>
  );
}

export default EditTranslationLanguage;
